import { LucideProps } from 'lucide-react';

export const ArrowCircleIcon = (props: LucideProps) => (
  <svg
    width="73"
    height="73"
    viewBox="0 0 73 73"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M51.5 10.5508C60.467 15.7379 66.5 25.4331 66.5 36.5373C66.5 53.1059 53.0685 66.5373 36.5 66.5373C19.9315 66.5373 6.5 53.1059 6.5 36.5373C6.5 25.4331 12.533 15.7379 21.5 10.5508M24.5 36.5371L36.5 48.5371M36.5 48.5371L48.5 36.5371M36.5 48.5371L36.5 6.53711"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
